<svelte:options immutable={true} />

<script lang="ts">
  import { onMount, createEventDispatcher } from "svelte";
  import Selectbox from "./Selectbox.svelte";
  import {
    readAsArrayBuffer,
    readAsImage,
    readAsPDF,
    readAsDataURL,
  } from "./utils/asyncReader.js";
  import { save, getData } from "./utils/PDF.js";
  import CheckMark from "./CheckMark.svelte";
  import CopyClipBoard from "./CopyClipBoard.svelte";
  import Packets from "./Packets.svelte";
  import { buildSignUrl } from "./utils/signPublicUrl.js";
  import PacketsModal from "./components/popups/PacketsModal.svelte";
  const dispatch = createEventDispatcher();
  export let templates;
  export let blog;
  export let user;
  export let chatUsers;
  export let merusToken;
  export let signColor;
  export let editTemplatesAvailable;
  export let tutorialStep = 0;
  export let tutorialNumber = 0;
  export let fluentCaseToken;
  export let merusCaseEnabled;
  export let fluentCaseEnabled;
  export let emailSubject;
  export let emailCC;
  export let friends;
  export let twilioEnabled = false;
  let templateId = 0;
  let newTempName = "";
  let sharepointVal = "";
  let merusUserId = "";
  let activity_type_id = "";
  let fluent_tag_id = "";
  let eventType = "";
  let eventNumberOfDays = 0;
  let searchKeytemplate = "";
  let showtab = "";
  let checkIfEmail = false;
  let shareEmailPanel = false;
  let shareSMSPanel = false;
  let sending = false;
  let sendingSign = false;
  let sendPDFType = "";
  let selectedTemplate: any = null;
  let shareEmail = "";
  let shareEmailcc = "";
  let sendPDFRes = false;
  let clipboardTxt = "";
  let shareCaseFileId = "";
  let matterId = "";
  let shareUserId = "";
  let shareUserName = "";
  let expandPacket = false;
  let selectPacketTempIds = [];
  let merusCasesEnabled = false;
  let fileVineEnabled = false;
  let selectedChatUser = "";
  let showPacketsModal = false;
  let selectedPacket: any = null;
  let packets: any[] = [];
  let packetName = ""; 
  let packetId = 0;
  let templateIds: any[] = [];
  let packetsComponent: any = null;
  function loadTemplate(template) {
    dispatch("select", { template });
  }
  onMount(async () => {
    // displayTutorial(tutorialStep, tutorialNumber); 
    // merusCasesEnabled = user.merusCaseEnabled;
    fileVineEnabled = user.fileVineEnabled;
  });

  $: if (tutorialStep !== undefined) {
    displayTutorial(tutorialStep, tutorialNumber);
  }

  export async function displayTutorial(step, tutorialNum = 0) {
    tutorialNumber = tutorialNum;

    if (step === -1) {
      tutorialStep = (tutorialStep < 5) ? tutorialStep + 1 : 0;
    } else {
      tutorialStep = step;
    }
    switch (tutorialNumber) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;
      case 4:
        automateTemplateTutorial(tutorialStep);
        break;
      case 5:
        automateTemplateSharepointTutorial(tutorialStep);
        break;
    }

  }

  async function automateTemplateTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        break;
      case 4:
        // showSignatureTabFunc();
        // changeSignatureTabFunc("templates");
        if(templates.length > 0){
          showTempPanel(templates[0], "automation");
        }
        break;
      case 5:
        if(templates.length > 0){
          showTempPanel(templates[0], "automation");
        }
        break;
      case 6:
        break;
      case 7:
        break; 
      case 8:
        break;
  
    }
  }

  async function automateTemplateSharepointTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        break;
      case 4:
        if(templates.length > 0){
          showTempPanel(templates[0], "sharepoint");
        }
        break;
      case 5:
        break;
      case 6:
        break;
      case 7:
        break; 
      case 8:
        break;
  
    }
  }

  async function deleteTemplate(id) {
    if (confirm("Are you sure you want to delete the Template?") == true) {
      // signatureTabLoading = true;
      let body = {
        id: id,
        auth: "google",
        user_id: user.id,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=deleteSignatureTemplateForCloudflare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      templates = data.templates;
      // signatureTabLoading = false;
    }
  }
  async function showTempPanel(template, type) {
    templateId = template.id;
    activity_type_id = template.activity_type_id;
    sharepointVal = template.sharepoint;
    showtab = type;
    selectedTemplate = template;
    merusUserId = template.merusUserId;
    activity_type_id = template.activity_type_id;
    fluent_tag_id = template.fluent_tag_id;
    eventType = template.event_type;
    eventNumberOfDays = template.event_number_of_days;
  }
  async function shareEmailPanelFunc() {
    shareEmailPanel = true;
  }
  async function hideTempPanel() {
    templateId = 0;
    merusUserId = "";
    showtab = "";
    shareEmailPanel = false;
    shareSMSPanel = false;
    resetShareSendState();
    sendPDFType = "";
  }

  function resetShareSendState() {
    sendPDFRes = false;
    sendingSign = false;
    clipboardTxt = "";
    selectedChatUser = "";
    shareEmail = "";
    shareUserId = "";
    shareUserName = "";
    shareCaseFileId = "";
    matterId = "";
    checkIfEmail = false;
  }
  async function update_activity_type_id() {
    if (templateId > 0) {
      let body = {
        id: templateId,
        activity_type_id: activity_type_id,
        auth: "google",
        //user_id: user.id,
        user_id: user.appId,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=updateTemplateMerusActivityTypeIdForCloudflare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      templates = templates.map((template) =>
        template.id === templateId
          ? { ...template, activity_type_id }
          : template
      );
      merusUserId = "";
      templateId = 0;
      //templates = data.templates;
      showtab = "";
    }
  }

  async function update_template_event() {

    templates.forEach((template) => {
      if (template.id == templateId) {
        template.event_type = eventType;
        template.event_number_of_days = eventNumberOfDays;
      }
    });
    
    if (templateId > 0) {
      let body = {
        id: templateId,
        event_type: eventType,
        event_number_of_days: eventNumberOfDays,
        auth: "google",
        //user_id: user.id,
        user_id: user.appId,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=updateTemplateEvent",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      
      merusUserId = "";
      templateId = 0;
      //templates = data.templates;
      showtab = "";
    }
  }

  async function update_template_fluent_tag_id() {

    templates.forEach((template) => {
      if (template.id == templateId) {
        template.fluent_tag_id = fluent_tag_id;
      }
    });

    if (templateId > 0) {
      let body = {
        id: templateId,
        fluent_tag_id: fluent_tag_id,
        auth: "google",
        //user_id: user.id,
        user_id: user.appId,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=updateTemplateFluentTagId",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      merusUserId = "";
      templateId = 0;
      //templates = data.templates;
      showtab = "";
    }
  }

  async function updateMerusUserId() {
    if (templateId > 0 && merusUserId != "") {
      let body = {
        id: templateId,
        merusUserId: merusUserId,
        auth: "google",
        //user_id: user.id,
        user_id: user.appId,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=updateTemplateMerusUserIdForCloudflare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      merusUserId = "";
      templateId = 0;
      //templates = data.templates;
      showtab = "";
    }
  }
  async function renameTemplateName() {
    if (templateId > 0 && newTempName != "") {
      let body = {
        id: templateId,
        name: newTempName,
        auth: "google",
        user_id: user.id,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=updateTemplateNameForCloudflare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      newTempName = "";
      templateId = 0;
      //templates = data.templates;
      showtab = "";
    }
  }
  async function sharepointTemplate() {

    
    if (templateId > 0 ) {
      templates.forEach((template) => {
        if (template.id == templateId) {
          template.sharepoint = sharepointVal;
        }
      });
      let body = {
        id: templateId,
        sharepoint: sharepointVal,
        auth: "google",
        //user_id: user.id,
        user_id: user.appId,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=updateTemplateSharepoint",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      merusUserId = "";
      templateId = 0;
      //templates = data.templates;
      showtab = "";
    }
  }

  function checkIfEmailFunc() {
    // Regular expression to check if string is email
    const regexExp =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

    checkIfEmail = regexExp.test(shareEmail);
  }

  async function handleChatUserSelect(event) {
    selectedChatUser = event.detail.item;
    shareEmail = event.detail.item.email;
    if (event.detail.item.id != "") {
      shareUserId = event.detail.item.id;
      shareUserName = event.detail.item.fullName;
      shareCaseFileId = event.detail.item.advanced.caseFileIds.toString();
      if (event.detail.item.fluentCaseMattersIds && event.detail.item.fluentCaseMattersIds.length > 0) {
        matterId = event.detail.item.fluentCaseMattersIds[0].toString();
      }
      // const matter = event.detail.item.tags.find(tag => tag.name === "matterId");
      // matterId = matter ? matter.id : "";
    }
    checkIfEmailFunc();
  }
  async function handleChatUserEnterEmail(event) {
    shareEmail = event.detail.item.email;
    shareUserId = "";
    shareUserName = "";
    shareCaseFileId = "";
    checkIfEmailFunc();
  }

  function handleItemAdded(event) {
    const newItem = event.detail.item;
    // Add the new item to chatUsers if it doesn't already exist
    const existingIndex = chatUsers.findIndex(u => u.id === newItem.id);
    if (existingIndex === -1) {
      chatUsers = [...chatUsers, newItem];
    } else {
      // Update existing item
      chatUsers = chatUsers.map(u => u.id === newItem.id ? newItem : u);
    }
  }

  function handleItemUpdated(event) {
    const updated = event.detail?.item;
    if (!updated?.id) return;
    const existingIndex = chatUsers.findIndex((u) => u.id === updated.id);
    if (existingIndex === -1) {
      chatUsers = [...chatUsers, updated];
      return;
    }
    chatUsers = chatUsers.map((u) =>
      u.id === updated.id ? { ...u, ...updated, assignedTo: updated.assignedTo ?? u.assignedTo } : u
    );
  }

  async function getSignatureOptions(contact_id = 0) {
    let ajaxBody = { url: selectedTemplate.pdfUrl, auth: "google" };
    const res = await fetch(
      blog.siteurl + "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
      {
        method: "POST",
        body: JSON.stringify(ajaxBody),
      }
    );
    let pdfFile = await res.blob();
    const pdf = await readAsPDF(pdfFile);
    let allObjects = JSON.parse(selectedTemplate.allObjects || '[]');
    if (!Array.isArray(allObjects)) allObjects = [];
    const numPages = pdf.numPages;
    while (allObjects.length < numPages) allObjects.push([]);
    const pagesScale = Array(numPages).fill(1);
    const pdfName = selectedTemplate.pdfName;
    const prePdfData = await getData(pdfFile, allObjects, pdfName, pagesScale);
    let pdfData = prePdfData[0];
    let optionData = prePdfData[1];
    let sign1 = "";
    let sign2 = "";
    let sign3 = "";
    let sign4 = "";
    let sign5 = "";
    let sign6 = "";
    for (let i = 0; i < optionData.length; i++) {
      const pageNum = optionData[i].pageIndex + 1;
      let pageWidth = optionData[i].pageWidth;
      let pageHeight = optionData[i].pageHeight;
      let size = optionData[i].size;
      if (pageWidth == 792 && pageHeight == 612) {
        if (optionData[0].pageWidth == 612 && optionData[0].pageHeight == 792) {
          pageWidth = 612;
          pageHeight = 792;
        }
      }
      if (optionData[i].type == "text") {
        //console.log(optionData[i].pageWidth, optionData[i].pageHeight);
        let posX = optionData[i].x / pageWidth;
        let posY = (optionData[i].y + 15) / pageHeight;
        if (optionData[i].text == "Initial") {
          if (sign2 == "") {
            sign2 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign2 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else if (optionData[i].text == "Date") {
          if (sign3 == "") {
            sign3 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign3 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else if (optionData[i].text == "Name") {
          if (sign4 == "") {
            sign4 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign4 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else {
          //console.log("optionData", i, optionData);
          if (sign5 == "") {
            sign5 +=
              pageNum + ":" + posX + ":" + posY + ":" + optionData[i].text.replace(/,/g, "-*-").replace(/:/g, "_*_") + ":" + size;
          } else {
            sign5 +=
              "," +
              pageNum +
              ":" +
              posX +
              ":" +
              posY +
              ":" +
              optionData[i].text.replace(/,/g, "-*-").replace(/:/g, "_*_") + ":" + size;
          }
        }
      } else {
        let posX = optionData[i].x / pageWidth;
        let posY = optionData[i].y / (pageHeight - 23);
        if (optionData[i].type == "quickSign") {
          let path = optionData[i].url.replace(blog.siteurl, "");
          if (sign6 == "") {
            sign6 += pageNum + ":" + posX + ":" + posY + ":" + path;
          } else {
            sign6 += "," + pageNum + ":" + posX + ":" + posY + ":" + path;
          }
        }
        if (optionData[i].type == "Signature") {
          if (sign1 == "") {
            sign1 += pageNum + ":" + posX + ":" + posY;
          } else {
            sign1 += "," + pageNum + ":" + posX + ":" + posY;
          }
        }
      }
    }
    let timestamp = 0;
    let option1 = sign1 + "--*--" + sign3;
    let option2 =
      sign2 +
      "--*--" +
      sign4 +
      "--*--" +
      sign5 +
      "--*--letter--*--" +
      timestamp +
      "--*--" +
      sign6;
    let display_name = "google_" + user.name;
    let body = {
      author_id: user.id,
      author: display_name,
      contact_id: contact_id,
      pdfData: pdfData,
      pdfName: pdfName && !pdfName.toLowerCase().endsWith('.pdf') ? pdfName + '.pdf' : pdfName,
      option1: option1,
      option2: option2,
      sendPDFType: sendPDFType,
      allObjects: allObjects,
    };
    return body;
  }
  async function sendSignature(
    contact_id = 0,
    cblog = "",
    tw_b_id = 0,
    phone = "",
    email = "",
    cc = ""
  ) {
    if (sending) return;
    sending = true;
    try {
      clipboardTxt = "";
      sendingSign = true;
      // usersPanel = true;
      let body = await getSignatureOptions(contact_id);
      body.newName = "";
      body.lang = "en";
      body.color = signColor;
      if (cblog != "") body.blog = cblog;
      body.tw_b_id = tw_b_id;
      body.phone = phone;
      body.email = email;
      body.user_id = shareUserId || (selectedChatUser && selectedChatUser.id) || "";
      body.user_name = shareUserName || (selectedChatUser && selectedChatUser.fullName) || "";
      body.user_caseFileId = merusCaseEnabled ? shareCaseFileId : "";
      body.user_matterId = fluentCaseEnabled ? matterId : "";
      body.cc = cc;
      body.staff_id = user.id;
      body.staff_email = user.email;
      body.staff_name = user.name;
      body.appId = user.appId;
      body.merusUserId = selectedTemplate.merusUserId;
      body.merusActivityTypeId = selectedTemplate.activity_type_id;
      body.fluentCaseTagId = selectedTemplate.fluent_tag_id;
      body.sharepoint = selectedTemplate.sharepoint;
      body.event_type = selectedTemplate.event_type;
      body.event_number_of_days = selectedTemplate.event_number_of_days;
      body.sendEmailSubject = emailSubject;
      body.emailCC = emailCC;
      body.fluentcaseToken = fluentCaseToken;
      body.packetName = selectedPacket ? selectedPacket.packetName : "";
      body.send_type = sendPDFType;
      const req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=updateContactPost",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      if (data) {
        if ( selectedTemplate.event_type != "" && sendPDFType == "email") {

          const date = new Date();
          date.setDate(date.getDate() + parseInt(selectedTemplate.event_number_of_days));

          let newEvent = {
            name: shareUserName + " - " + selectedTemplate.pdfName, 
            details: '',
            creator: '',
            eventDate: ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear(),
            eventTime: date.toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3"),
            eventTimestamp: +date,
            eventType: selectedTemplate.event_type,
            location: '',
            members: [],
            timestamp: Date.now()
          };

          selectedChatUser.events.push(newEvent);

          fetch('https://api.qix.cloud/conversation', {
            method: 'PUT',
            body: JSON.stringify(selectedChatUser),
            headers: {
              'Content-Type': 'application/json',
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });


        }
      }

      //alert('Sent successfully!.');

      shareEmail = "";
      shareUserId = "";
      shareUserName = "";
      shareCaseFileId = "";
      if (sendPDFType == "link" || sendPDFType == "sms") {
        clipboardTxt = buildSignUrl(data.id);
      }
      sendPDFRes = true;
      //await getUsersFunc();
    } catch (e) {
      // Error handling
    } finally {
      sending = false;
      //selectedUser = "";
    }
    sendingSign = false;
    //smsLang = "";
  }

  
  async function updateEmailSettings() {
    let body = { user_id: user.id, sentEmailSubject: emailSubject, cc: emailCC, save: true };
    const req = await fetch(
      blog.siteurl + "/ajax/emailSettings.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
  }

  function syncShareUserFromChat(chatUser) {
    if (!chatUser) return;
    if (chatUser.id != null && chatUser.id !== "") {
      shareUserId = chatUser.id;
    }
    if (chatUser.fullName) {
      shareUserName = chatUser.fullName;
    }
  }

  async function handleSendSMS(event) {
    const modifiedUser = event.detail.modifiedUser;
    if (modifiedUser) {
      // Update the selectedChatUser with the modified one (which has selected IDs only)
      selectedChatUser = modifiedUser;
      // Set the caseFileId and matterId from the modified user
      if (modifiedUser.advanced && modifiedUser.advanced.caseFileIds && modifiedUser.advanced.caseFileIds.length > 0) {
        shareCaseFileId = modifiedUser.advanced.caseFileIds[0];
      }
      if (modifiedUser.fluentCaseMattersIds && modifiedUser.fluentCaseMattersIds.length > 0) {
        matterId = modifiedUser.fluentCaseMattersIds[0];
      }
    }
    syncShareUserFromChat(modifiedUser || selectedChatUser);
    await sendSignature(0, 1, 1, "", "", emailCC);
    let res = await fetch("https://api.qix.cloud/message", {
      headers: {
        accept: "*/*",
        "accept-language": "en-US,en;q=0.9,ar;q=0.8",
        authorization:
          "Bearer " + localStorage.getItem("token"),
        "content-type": "application/json",
        "sec-ch-ua": '"Chromium";v="136", "Microsoft Edge";v="136", "Not.A/Brand";v="99"',
        "sec-ch-ua-mobile": "?0",
        "sec-ch-ua-platform": '"Windows"',
        "sec-fetch-dest": "empty",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "cross-site",
        Referer: "https://qixcloud-chat.pages.dev/",
        "Referrer-Policy": "strict-origin-when-cross-origin",
      },
      body: JSON.stringify({
        chat: selectedChatUser.id,
        message: emailSubject + "\n" + clipboardTxt,
        twilio: user.appId,
        sendToFileVine: false,
      }),
      method: "POST",
    });
  }


  async function sendSignatureHandle(type, event = null) {
    if (type == "link") {
      resetShareSendState();
      shareSMSPanel = false;
      shareEmailPanel = false;
      sendPDFType = "link";
      sendSignature(0);
    } else if (type == "email") {
      // Handle modifiedUser if provided (for multi-ID selection)
      if (event && event.detail && event.detail.modifiedUser) {
        const modifiedUser = event.detail.modifiedUser;
        // Update the selectedChatUser with the modified one (which has selected IDs only)
        selectedChatUser = modifiedUser;
        // Set the caseFileId and matterId from the modified user
        if (modifiedUser.advanced && modifiedUser.advanced.caseFileIds && modifiedUser.advanced.caseFileIds.length > 0) {
          shareCaseFileId = modifiedUser.advanced.caseFileIds[0];
        }
        if (modifiedUser.fluentCaseMattersIds && modifiedUser.fluentCaseMattersIds.length > 0) {
          matterId = modifiedUser.fluentCaseMattersIds[0];
        }
        syncShareUserFromChat(modifiedUser);
      }
      updateEmailSettings();
      sendPDFType = "email";
      sendSignature(0, 1, 1, "", shareEmail, emailCC);
    } else if (type == "sms") {
      handleSendSMS(event);
    }
  }
  const copy = () => {
    const app = new CopyClipBoard({
      target: document.getElementById("clipboard"),
      props: { clipboardTxt },
    });

    app.$destroy();
    //clipboardTxt = "";
    //usersPanel = false;
    alert("Copied.");
  };
  async function getEmailSettings() {
    let body = { user_id: user.id };

    const req = await fetch(
      blog.siteurl + "/ajax/emailSettings.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    emailSubject = res.sentEmailSubject != "" ? res.sentEmailSubject : "Hello [user_name], [staff_name] here with the document link / [company_name]";
    emailCC = res.cc != "" ? res.cc : "";
    return emailSubject;
  }

  async function showShareSMSPanel() {
    resetShareSendState();
    shareEmailPanel = false;
    shareSMSPanel = true;
    emailSubject = "";
    sendPDFType = "sms";
  }
  async function showShareEmailPanel() {
    resetShareSendState();
    shareSMSPanel = false;
    await getEmailSettings();
    shareEmailPanel = true;
    sendPDFType = "email";
  }

  // Lock menu chrome collapse while share / packets UI is open (mobile)
  $: {
    const lock =
      showtab === 'share' ||
      shareEmailPanel ||
      shareSMSPanel ||
      sendPDFRes ||
      showPacketsModal ||
      expandPacket;
    dispatch('chromeLock', { lock });
  }

  async function handleExpandPackets(event) {
    expandPacket = event.detail;
    if (!expandPacket) {
      // Back to Templates / cancel: clear packet chip so Packets button returns
      selectedPacket = null;
      selectPacketTempIds = [];
    }
  }
  async function handleSelectPackets(event) {
    selectPacketTempIds = event.detail;
  }

  async function handlePacketUpdated(event) {
    // Refresh packets list after update
    await getPackets();
    // Clear edit state
    packetName = "";
    packetId = 0;
    templateIds = [];
    expandPacket = false;
  }

  async function openPacketsModal() {
    showPacketsModal = true;
    // Load packets when opening modal
    await getPackets();
  }

  async function closePacketsModal() {
    showPacketsModal = false;
  }

  async function selectPacketFromModal(event: any) {
    if (event.detail) {
      selectedPacket = event.detail;
      
      if (selectedPacket.templateIds) {
        selectPacketTempIds = JSON.parse(selectedPacket.templateIds);
      } else {
        selectPacketTempIds = [];
      }
      
      showPacketsModal = false;
    }
  }

  async function getPackets() {
    // Local mock for mobile UX / smoke tests
    try {
      if (typeof window !== 'undefined' &&
          new URLSearchParams(window.location.search).get('mockUser') === '1') {
        packets = [
          {
            id: 1,
            packetName: 'Test Packet With A Very Long Name For Layout',
            templateIds: JSON.stringify(['t1']),
          },
          {
            id: 2,
            packetName: 'WC Contracts Without FD Packet',
            templateIds: JSON.stringify(['t1', 't2']),
          },
          {
            id: 3,
            packetName: 'Personal Injury Intake + HIPAA + Retainer Bundle',
            templateIds: JSON.stringify(['t3', 't4']),
          },
        ];
        return;
      }
    } catch (_) {
      /* ignore */
    }

    let body = new URLSearchParams();
    body.append("action", "getPackets");
    body.append("appId", user.appId);
    
    const req = await fetch(blog.siteurl + "/ajax/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    });
    
    const responseData = await req.json();
    packets = responseData;
  }

  async function createNewPacket() {
    // Open the packet creation interface
    expandPacket = true;
    showPacketsModal = false;
    
    // Call displayCreatePopup on the Packets component
    if (packetsComponent) {
      packetsComponent.displayCreatePopup();
    }
  }

  async function editPacketFromModal(event: any) {
    const packet = event.detail;
    
    if (packet) {
      // Close the modal first
      showPacketsModal = false;
      
      // Use the Packets component's editSelectedPacket function
      if (packetsComponent) {
        packetsComponent.editSelectedPacket(packet);
      }
      
      // Set the states to show the edit interface
      expandPacket = true;
    }
  }

  async function deletePacketFromModal(event: any) {
    const packet = event.detail;
    if (confirm("Are you sure you want to delete this packet?")) {
      let body = new URLSearchParams();
      body.append("action", "deletePacket");
      body.append("id", packet.id);
      body.append("appId", user.appId);
      const req = await fetch(blog.siteurl + "/ajax/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body.toString(),
      });
      packets = await req.json();
    }
  }

  async function editSelectedPacket() {
    if (selectedPacket) {
      // Use the same logic as the old editPacket function from Packets.svelte
      templateIds = JSON.parse(selectedPacket.templateIds);
      
      packetName = selectedPacket.packetName;
      packetId = parseInt(selectedPacket.id);
      
      // Mark templates as selected/unselected (same logic as Packets.svelte)
      templates.forEach((data) => {
        if (templateIds.includes(data.id)) {
          data.selected = true;
        } else {
          data.selected = false;
        }
      });
      
      // Set expandPacket to true to show the Packets component
      expandPacket = true;
      showPacketsModal = false;
    }
  }

  async function deleteSelectedPacket() {
    if (selectedPacket && confirm("Are you sure you want to delete this packet?")) {
      // Use the existing deletePacket function from Packets component
      let body = new URLSearchParams();
      body.append("action", "deletePacket");
      body.append("id", selectedPacket.id);
      body.append("appId", user.appId);
      const req = await fetch(blog.siteurl + "/ajax/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body.toString(),
      });
      packets = await req.json();
      // Clear selection after deletion
      selectedPacket = null;
      selectPacketTempIds = [];
    }
  }

  async function shareSelectedPacket() {
    if (selectedPacket) {
      // Set the packet data for sharing
      packetName = selectedPacket.packetName;
      packetId = parseInt(selectedPacket.id);
      templateIds = JSON.parse(selectedPacket.templateIds);
      
      // Expand the packets component to show share interface
      expandPacket = true;
      
      // We need to trigger the share functionality in the Packets component
      // This will be handled by the Packets component when it receives the packet data
    }
  }
</script>
<style lang="scss">
* {
  &::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}
&::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(83, 83, 83, 0.07);
  background-color: #f1f1f1;
}
&::-webkit-scrollbar {
  width: 7px;
  background-color: #f1f1f1;
}
&::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
}

.hidden {
  display: none !important;
}

.search-packets-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 1em;
  flex-wrap: nowrap;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 767px) {
  .template-wrapper {
    max-width: 100%;
    overflow-x: hidden !important;
  }

  .search-packets-container {
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }

  .search-input {
    flex: 1 1 100%;
    min-width: 0;
    width: 100%;
  }

  .packets-button-container {
    flex: 1 1 auto;
    min-width: 0;
  }

  .packets-button {
    width: 100%;
    justify-content: center;
  }

  /* Template cards — keep Delete inside the card */
  .signItem {
    max-width: 100%;
    width: auto;
    box-sizing: border-box;
    overflow: hidden;
    margin-left: 8px;
    margin-right: 8px;
  }

  .signItem > div:first-child {
    min-width: 0;
    max-width: 100%;
  }

  .signItem > div:first-child > div {
    word-break: break-word;
    overflow-wrap: anywhere;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.3;
  }

  .signItem .action,
  .signItem .action > div {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 8px 12px !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .signItem .action > div > span {
    margin-right: 0 !important;
    flex: 0 0 auto;
    white-space: nowrap;
    font-size: 0.85rem;
  }

  .signItem .action > div > span.delete {
    color: #dc2626;
  }
}

.search-input {
  flex: 1;
  background: white;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  font-size: 14px;
  height: 40px;
  box-sizing: border-box;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.packets-button-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.packets-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  color: #1f2937;
  border: 1px solid #d1d5db;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
  white-space: nowrap;
  height: 40px;
  box-sizing: border-box;
}

.packets-button:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.packets-button.selected-packet {
  background: #dbeafe;
  border-color: #3b82f6;
  color: #1e40af;
}

.packets-button.selected-packet:hover {
  background: #bfdbfe;
}

.packet-action-button {
  background: #f8f9fa;
  border: 1px solid #d1d5db;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  height: 32px;
  width: 32px;
  box-sizing: border-box;
}

.packet-action-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  transform: translateY(-1px);
}

.packet-action-button.edit:hover {
  background-color: #e3f2fd;
  border-color: #90caf9;
}

.packet-action-button.delete:hover {
  background-color: #ffebee;
  border-color: #ef9a9a;
}

.clear-packet-button {
  background: transparent;
  color: white;
  border: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  opacity: 0.8;
}

.clear-packet-button:hover {
  background: rgba(255, 255, 255, 0.2);
  opacity: 1;
  transform: scale(1.1);
}

.packets-icon {
  width: 16px;
  height: 16px;
  opacity: 1;
}

.action-icon {
  width: 16px;
  height: 16px;
  opacity: 0.8;
  filter: grayscale(0.3);
}

.packet-action-button:hover .action-icon {
  opacity: 1;
  filter: grayscale(0);
}

.packet-action-button.edit .action-icon {
  filter: grayscale(0.2) hue-rotate(200deg);
}

.packet-action-button.delete .action-icon {
  filter: grayscale(0.2) hue-rotate(0deg);
}

.selected-packet-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.packet-tag {
  display: flex;
  align-items: center;
  background: #3b82f6;
  color: white;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
}

.packet-name {
  white-space: nowrap;
}

.share-packet-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #3b82f6;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  height: 40px;
  box-sizing: border-box;
}

.share-packet-button:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.share-icon {
  width: 16px;
  height: 16px;
  opacity: 1;
  filter: brightness(0) invert(1);
}

</style>
<div
  class="template-wrapper"
  class:template-wrapper--sharing={
    showtab === 'share' || shareEmailPanel || shareSMSPanel || sendPDFRes
  }
  style="height: 100%; overflow: auto;"
  data-menu-chrome-scroll={
    showtab === 'share' || shareEmailPanel || shareSMSPanel || sendPDFRes
      ? undefined
      : ''
  }
  data-no-chrome-scroll={
    showtab === 'share' || shareEmailPanel || shareSMSPanel || sendPDFRes
      ? ''
      : undefined
  }
>
  <div style="position: sticky; top: 0; background: white; z-index: 10; flex-shrink: 0;">
    <div style="margin: 10px">
      <!-- Search and Packets - Hidden only when editing packet -->
      <div class="search-packets-container" class:hidden={expandPacket}>
        <input
          placeholder="Search Template"
          type="text"
          class="search-input"
          bind:value={searchKeytemplate}
        />
        
        <!-- Packets Button (hidden when packet is selected) -->
        <div class="packets-button-container" class:hidden={selectedPacket}>
          <button 
            class="packets-button"
            on:click={openPacketsModal}
          >
            <img src="/packet.png" alt="Packets" class="packets-icon" />
            Packets
          </button>
        </div>
        
        <!-- Selected Packet Display (shown when packet is selected) -->
        {#if selectedPacket}
          <div class="selected-packet-container">
            <div class="packet-tag">
              <span class="packet-name">{selectedPacket.packetName}</span>
              <button 
                class="clear-packet-button"
                on:click={() => {
                  selectedPacket = null;
                  selectPacketTempIds = [];
                }}
                title="Clear packet selection"
              >
                ×
              </button>
            </div>
            <button 
              class="share-packet-button"
              on:click={shareSelectedPacket}
              title="Share Packet"
            >
              <img src="/send.png" alt="Share" class="share-icon" />
              Share
            </button>
          </div>
        {/if}
      </div>
    </div>
  </div>

  <!-- Packets Modal -->
  <PacketsModal
    {packets}
    selectedPacketId={selectedPacket?.id || ""}
    isOpen={showPacketsModal}
    on:select={selectPacketFromModal}
    on:close={closePacketsModal}
    on:create={createNewPacket}
    on:edit={editPacketFromModal}
    on:delete={deletePacketFromModal}
  />

  <!-- Packet Creation/Edit Interface -->
  <div class:hidden={!expandPacket}>
    <Packets
      bind:this={packetsComponent}
      {templates}
      {blog}
      {user}
      {chatUsers}
      {merusToken}
      {tutorialNumber}
      {tutorialStep}
      bind:emailSubject={emailSubject}
      bind:emailCC={emailCC}
      bind:friends={friends}
      bind:fluentCaseEnabled={fluentCaseEnabled}
      bind:fluentCaseToken={fluentCaseToken}
      bind:merusCaseEnabled={merusCaseEnabled}
      bind:twilioEnabled={twilioEnabled}
      bind:packetName={packetName}
      bind:packetId={packetId}
      bind:templateIds={templateIds}
      bind:searchKeytemplate={searchKeytemplate}
      on:expand={handleExpandPackets}
      on:select={handleSelectPackets}
      on:packetUpdated={handlePacketUpdated}
    />
  </div>
  {#if templates.length > 0}
    <!-- <div class:hidden={showRenameTemp || showTaskTemp || showActivityTemp}> -->
    <div class:hidden={showtab != "" || expandPacket}>
      {#each templates as template}
        {#if (selectPacketTempIds.length == 0 && (searchKeytemplate == "" || template.pdfName
              .toLowerCase()
              .includes(searchKeytemplate.toLowerCase()))) || (selectPacketTempIds.includes(template.id) && (searchKeytemplate == "" || template.pdfName
              .toLowerCase()
              .includes(searchKeytemplate.toLowerCase())))}
          <div class="signItem" class:border-green={tutorialStep == 7 && tutorialNumber == 2}>
            

            <div>
              <div>{template.pdfName}</div>
            </div>
            <div class="action w-full flex items-center">
              <div class="flex items-center">
                <span class="load" on:click={() => loadTemplate(template)}
                  >Load</span
                >
                <span
                  class="share"
                  on:click={() => showTempPanel(template, "share")}>Share</span
                >
                {#if editTemplatesAvailable || user.appId == user.id}
                  {#if user.microsoft || user.id == "WXGQglBzvBxotzUznSAi"}
                    <span
                      class="share"
                      class:border-green={(tutorialStep == 3 && tutorialNumber == 5)}
                      on:click={() => showTempPanel(template, "sharepoint")}
                      >Sharepoint</span
                    >
                  {/if}
                  <span
                    class="rename"
                    on:click={() => showTempPanel(template, "rename")}
                    >Rename</span
                  >
                  <span
                    class="rename"
                    class:border-green={(tutorialStep == 3 && tutorialNumber == 4)}
                    on:click={() => showTempPanel(template, "automation")}
                    >Automation</span
                  >
                  {#if template.author_id == user.id}
                  <!-- {#if true} -->
                    <span
                      class="delete"
                      on:click={() => deleteTemplate(template.id)}>Delete</span
                    >
                  {/if}
                {/if}
              </div>
            </div>
          </div>
        {/if}
      {/each}
    </div>
    {#if showtab == "share"}
      <div style="padding: 10px;">
        <span
          on:click={hideTempPanel}
          class="cursor-pointer"
          style="float: right;font-size: 1.5rem;margin-top: -1rem;">×</span
        >
        <div class="p-2 flex" style="gap: 20px;">
          <label
            class="flex items-center h-full hover:bg-gray-500
          cursor-pointer px-2 py-1"
            on:click={() => sendSignatureHandle("link")}
          >
            <img
              alt=""
              src="link.svg"
              style="width: 30px; margin-right: 15px;"
            />
            <span>Link</span>
          </label>
          <label
            class="flex items-center h-full hover:bg-gray-500
          cursor-pointer px-2 py-1"
            on:click={() => showShareEmailPanel()}
          >
            <img
              alt=""
              src="mail.svg"
              style="width: 30px; margin-right: 15px;"
            />
            <span>Email</span>
          </label>
            <label
            class="flex items-center h-full hover:bg-gray-500
          cursor-pointer px-2 py-1"
            on:click={() => showShareSMSPanel()}
          >
            <img
              alt=""
              src="sms.svg"
              style="width: 30px; margin-right: 15px;"
            />
            <span>SMS</span>
          </label>
        </div>
        {#if shareEmailPanel && sendPDFType != "link" && !sendPDFRes }
          <div class="flex" style="min-height: 220px;" data-no-chrome-scroll>
            <Selectbox
              bind:emailSubject={emailSubject}
              bind:emailCC={emailCC}
              bind:friends={friends}
              items={chatUsers}
              type="email"
              placeholder="Enter Email"
              {merusToken}
              bind:fluentCaseEnabled={fluentCaseEnabled}
              bind:fluentCaseToken={fluentCaseToken}
              bind:merusCaseEnabled={merusCaseEnabled}
              bind:selectedChatUser={selectedChatUser}
              bind:checkIfEmailExternal={checkIfEmail}
              appId={user.appId}
              {user}
              on:select={handleChatUserSelect}
              on:enterEmail={handleChatUserEnterEmail}
              on:send={(event) => sendSignatureHandle("email", event)}
              on:itemAdded={handleItemAdded}
              on:itemUpdated={handleItemUpdated}
            />
          </div>
          <!-- {#if checkIfEmail}
            <button
              class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
              style="
              margin-top: 15px;
              display: flex;
              align-items: center;
              margin-left: auto;max-height: 35px;"
              on:click={() => sendSignatureHandle("email")}
            >
              <img
                alt=""
                src="mail_w.png"
                style="width: 25px; margin-right: 15px;"
              /> Send</button
            >
          {:else}
            <button
              class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
              style="
              margin-top: 15px;
              display: flex;
              align-items: center;
              margin-left: auto;
              background: grey;max-height: 35px;"
              ><img
                alt=""
                src="mail_w.png"
                style="width: 25px; margin-right: 15px;"
              /> Send</button
            >
          {/if} -->

        {:else}
          {#if shareSMSPanel && sendPDFType != "link" && !sendPDFRes && !((sendPDFType == "sms") && !twilioEnabled)}
            <div class="flex" style="min-height: 220px;" data-no-chrome-scroll>
            <Selectbox
              bind:emailSubject={emailSubject}
              bind:emailCC={emailCC}
              bind:friends={friends}
              items={chatUsers}
              type="sms"
              placeholder="Select a User"
              {merusToken}
              bind:fluentCaseEnabled={fluentCaseEnabled}
              bind:fluentCaseToken={fluentCaseToken}
              bind:merusCaseEnabled={merusCaseEnabled}
              bind:selectedChatUser={selectedChatUser}
              bind:checkIfEmailExternal={checkIfEmail}
              appId={user.appId}
              {user}
              on:select={handleChatUserSelect}
              on:enterEmail={handleChatUserEnterEmail}
              on:send={(event) => sendSignatureHandle("sms", event)}
              on:itemAdded={handleItemAdded}
              on:itemUpdated={handleItemUpdated}
            />
          </div>
          <!-- {#if selectedChatUser}
            <button
              class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
              style="
              margin-top: 15px;
              display: flex;
              align-items: center;
              margin-left: auto;max-height: 35px;"
              on:click={() => sendSignatureHandle("sms")}
            >
              <img
                alt=""
                src="sms.svg"
                style="width: 25px; margin-right: 15px;"
              /> Send</button
            >
          {:else}
            <button
              class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
              style="
              margin-top: 15px;
              display: flex;
              align-items: center;
              margin-left: auto;
              background: grey;max-height: 35px;"
              ><img
                alt=""
                src="sms.svg"
                style="width: 25px; margin-right: 15px;"
              /> Send</button
            >
            {/if} -->
          {/if}
        {/if}
        {#if sendingSign}
          <div
            class="flex items-center"
            style="justify-content: space-between; max-width: 200px;"
          >
            <span class:hidden={sendPDFType != "link"}>Generating Link</span>
            <img alt="" src="/loading.gif" style="max-width: 30px;" />
          </div>
        {:else if (sendPDFType == "sms") && !twilioEnabled}
          <div
            class="flex items-center"
            style="justify-content: space-between;"
          >
            <span >You do not have SMS enabled</span>
          </div>
        {:else if sendPDFRes}
          {#if sendPDFType != "link"}
            <div class="w-full half-w-md mx-auto p-2 bg-white rounded-lg">
              <div class="flex items-center gap-2 mb-4">
                <span class="text-lg font-semibold text-gray-700">Sent Successfully</span>
                <CheckMark />
              </div>
              <p class="text-gray-500 text-sm mb-6 leading-relaxed">
                To: {selectedChatUser.fullName} +{selectedChatUser.phone}<br />
                {selectedChatUser.email}
              </p>
              <div class="flex gap-4">
                <a href="https://legalpal.app/chat?chatId={selectedChatUser.id}" target="_blank" class="flex-2 flex items-center justify-center gap-2 px-6 py-2 border-2 border-blue-400 text-blue-500 rounded-2xl hover:bg-blue-50 transition-colors font-medium text-sm">
                  <img alt="conversation icon" src="/img/chatAsset.svg" class="w-5 h-5" />
                  Jump to Conversation
                </a>
                {#if fluentCaseEnabled && selectedChatUser.fluentCaseMattersIds && selectedChatUser.fluentCaseMattersIds.length > 0}
                  <a href="https://app.fluentcase.com/matters/{selectedChatUser.fluentCaseMattersIds[0]}" target="_blank" class="flex-2 flex items-center justify-center gap-2 px-6 py-2 border-2 border-pink-300 text-pink-500 rounded-2xl hover:bg-pink-50 transition-colors font-medium text-sm">
                    <img alt="case file icon" src="/fluentcase.svg" class="w-5 h-5" />
                    Open Case File
                  </a>
                {/if}
              </div>
            </div>
          {:else}
            <div id="clipboard" class="flex flex-col items-center space-y-2">
              <!-- Header -->
              <div class="flex items-center space-x-2 font-semibold text-lg" style="font-family: 'Quicksand', sans-serif;">
              <img
              src="/chat_icon.svg"
              alt="Chat Icon"
              class="w-5 h-5"
              style="color: currentColor;"
              />
              <span style="font-family: 'Quicksand', sans-serif;" >Your link is ready!</span>
              </div>
              
              <!-- Link box -->
                <div 
                on:click={copy} 
                class="flex items-center border border-blue-400 rounded-md px-5 py-3 max-w-full text-xl hover:bg-blue-100" 
                style="font-family: 'Quicksand', sans-serif;"
                >
              <a
              target="_blank"
              rel="noopener noreferrer"
              class="text-blue-600 truncate"
              style="font-family: 'Quicksand', sans-serif;"
              >
              {clipboardTxt}
              </a>
              <img
              src="/copy_icon.svg"
              alt="Copy"
              class="w-5 h-5 cursor-pointer ml-3"
              style="color: currentColor;"
              on:click={copy}
              />
              </div>
            </div> 
          {/if}
        {/if}
      </div>
    {/if}
    {#if showtab == "sharepoint"}
      <div style="padding: 10px;">
        <span
          on:click={hideTempPanel}
          class="cursor-pointer"
          style="float: right;font-size: 1.5rem;margin-top: -1rem;">×</span
        >
        <input
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px;"
          bind:value={sharepointVal}
        />
        <button
          on:click={sharepointTemplate}
          class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
          class:border-green={(tutorialStep == 4 && tutorialNumber == 5)}
          style="float: right; margin-top: 10px; margin-bottom: 5px;"
        >
          Save
        </button>
      </div>
    {/if}
    {#if showtab == "rename"}
      <div style="padding: 10px;">
        <span
          on:click={hideTempPanel}
          class="cursor-pointer"
          style="float: right;font-size: 1.5rem;margin-top: -1rem;">×</span
        >
        <input
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px;"
          bind:value={newTempName}
        />
        <button
          on:click={renameTemplateName}
          class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
          style="float: right; margin-top: 10px; margin-bottom: 5px;"
        >
          Update
        </button>
      </div>
    {/if}
    {#if showtab == "task"}
      <div style="padding: 10px;">
        <span
          on:click={hideTempPanel}
          class="cursor-pointer"
          style="float: right;font-size: 1.5rem;margin-top: -1rem;">×</span
        >
        <input
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px;"
          placeholder="Meruscase User ID"
          bind:value={merusUserId}
        />
        <button
          on:click={updateMerusUserId}
          class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
          style="float: right; margin-top: 10px; margin-bottom: 5px;"
        >
          Update
        </button>
      </div>
    {/if}
    {#if showtab == "activity"}
      <div style="padding: 10px;">
        <span
          on:click={hideTempPanel}
          class="cursor-pointer"
          style="float: right;font-size: 1.5rem;margin-top: -1rem;">×</span
        >
        <input
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px;"
          placeholder="Activity Type ID"
          bind:value={activity_type_id}
        />
        <button
          on:click={update_activity_type_id}
          class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
          style="float: right; margin-top: 10px; margin-bottom: 5px;"
        >
          Update
        </button>
      </div>
    {/if}
    {#if showtab == "automation"}
      <div style="padding: 10px;">
        <span
          on:click={hideTempPanel}
          class="cursor-pointer"
          style="float: right;font-size: 1.5rem;margin-top: -1rem;">×</span
        >
        {#if merusCaseEnabled}
        <h2 style="font-weight: 600;">Automation(MerusCase)</h2>
          <h3 style="clear: both;">Tag</h3>
          <div style="font-size: .9em;">
            Generate a Task and tag a Meruscase User
          </div>
          <input
            type="text"
            class="flex-grow bg-transparent py-1 px-2 w-full"
            style="border: 1px solid;border-radius: 5px;"
            placeholder="Meruscase User ID"
            bind:value={merusUserId}
            />
            <button
            on:click={updateMerusUserId}
            class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
            class:border-green={(tutorialStep == 5 && tutorialNumber == 4)}
            style="float: right; margin-top: 10px; margin-bottom: 5px;"
          >
            Update
          </button>
          <h3 style="clear: both;">Activity</h3>
          <div style="font-size: .9em;">
            Trigger a Workflow using an Activity Type
          </div>
          <input
            type="text"
            class="flex-grow bg-transparent py-1 px-2 w-full"
            style="border: 1px solid;border-radius: 5px;"
            placeholder="Activity Type ID"
            bind:value={activity_type_id}
            />
            <button
            on:click={update_activity_type_id}
            class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
            class:border-green={(tutorialStep == 4 && tutorialNumber == 4)}
            style="float: right; margin-top: 10px; margin-bottom: 5px;"
          >
            Update
          </button>
        {/if}
        {#if fluentCaseEnabled}
        <h2 style="font-weight: 600;">Automation(FluentCase)</h2>

          <h3 style="clear: both;">Activity</h3>
          <div style="font-size: .9em;">
            Generate a Task and tag a FluentCase User
          </div>
          <input
            type="text"
            class="flex-grow bg-transparent py-1 px-2 w-full"
            style="border: 1px solid;border-radius: 5px;"
            placeholder="FluentCase User ID"
            bind:value={fluent_tag_id}
            />
            <button
            on:click={update_template_fluent_tag_id}
            class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
            class:border-green={(tutorialStep == 4 && tutorialNumber == 4)}
            style="float: right; margin-top: 10px; margin-bottom: 5px;"
          >
            Update
          </button>
        {/if}
        {#if fileVineEnabled}
          <h2 style="font-weight: 600;clear: both;">Automation(FileVine)</h2>
        {/if}
        <h3 style="clear: both;">Event</h3>
        <div style="font-size: .9em;">
          Generate an Event using an Event Type
        </div>
        <input
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px; margin-bottom: 10px;"
          placeholder="Event Type"
          bind:value={eventType}
          />
          <input
          type="number"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px; margin-bottom: 5px;"
          placeholder="Event + (Number of Days)"
          bind:value={eventNumberOfDays}
          />
          <button
          on:click={update_template_event}
          class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
          style="float: right; margin-top: 10px; margin-bottom: 5px;"
        >
          Update
        </button>
      </div>
    {/if}
  {:else}
    <div class="text-center">There is no data.</div>
  {/if}
</div>
